import React from 'react';
import { useField } from 'formik';
import { Checkbox } from '@material-ui/core';

interface CheckboxFieldProps {
  name: string;
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
}

const CheckboxField = ({ name, setChecked, ...props }: CheckboxFieldProps): JSX.Element => {
  const [field, , helpers] = useField(name);

  const handleChange = (event: React.ChangeEvent<{ checked: boolean }>) => {
    helpers.setValue(event.target.checked);
    if (setChecked) {
      setChecked(event.target.checked);
    }
  };

  return <Checkbox {...props} checked={field.value} onChange={handleChange} />;
};

export default CheckboxField;
